import React from "react";
import { useState } from "react";
import Skills from "./Skills";
import Education from "./Education";
import Achievements from "./Achievements";
import { GiSkills, GiTrophy, GiBookCover } from "react-icons/gi";

function TabContainer() {
  const [tab, setTab] = useState(1);

  return (
    <div className="flex flex-col justify-center items-center ">
      {/* tabs */}
      <div className="flex w-[98%] md:w-[93%]  md:pt-0 h-14 -skew-x-[15deg] md:-skew-x-[40deg] bg-bodyColor dark:bg-darkBodyColor dark:border-[1px]  dark:border-darkContainerBorderColor shadow-xl lg:cursor-pointer ">
        <div
          onClick={() => setTab(1)}
          className={` w-full flex justify-center items-center transition ${
            tab === 1 ? "bg-firstColor text-darkTitleColor" : ""
          }`}
        >
          <div className="flex justify-left items-center gap-1 md:gap-2 skew-x-[15deg] md:skew-x-[40deg]">
            Skills
            <span className="font-bold text-xl">
              <GiSkills></GiSkills>
            </span>
          </div>
        </div>
        <div className=" w-4  bg-leetcodeBorderColor opacity-20 "></div>
        <div
          onClick={() => setTab(2)}
          className={` w-full flex justify-center items-center transition ${
            tab === 2 ? "bg-firstColor text-darkTitleColor" : ""
          }`}
        >
          <div className="flex justify-left items-center gap-1 md:gap-2 skew-x-[15deg] md:skew-x-[40deg]">
            Education
            <span className="font-bold text-lg">
              <GiBookCover></GiBookCover>
            </span>
          </div>
        </div>
        <div className=" w-4  bg-leetcodeBorderColor opacity-20 "></div>
        <div
          onClick={() => setTab(3)}
          className={` w-full flex justify-center items-center transition ${
            tab === 3 ? "bg-firstColor text-darkTitleColor" : ""
          }`}
        >
          <div className="flex justify-left items-center gap-1 md:gap-2 skew-x-[15deg] md:skew-x-[40deg]">
            Achievements
            <span className="font-bold text-xl">
              <GiTrophy></GiTrophy>
            </span>
          </div>
        </div>
      </div>
      <div className={tab === 1 ? "p-4 pt-8 w-full h-full" : ""}>
        {tab === 1 && <Skills />}
      </div>
      <div className={tab === 2 ? "p-4 pt-8 w-full h-full" : ""}>
        {tab === 2 && <Education />}{" "}
      </div>
      <div className={tab === 3 ? "p-4 pt-8 w-full h-full" : ""}>
        {tab === 3 && <Achievements />}{" "}
      </div>
    </div>
  );
}

export default TabContainer;
